import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";
const API_URL = process.env.VUE_APP_ROOT_API;

class TicketService {
  // Get All Tickets
  async getAllTickets(filter = "") {
    return await axios
      .get(API_URL + `crm/ticket${filter}`, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get Ticket Count
  async getTicketCount() {
    return await axios
      .get(API_URL + "crm/ticket-count", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add Bulk Ticket
  async addBulkTicket(data) {
    return await axios
      .post(API_URL + "crm/ticket-bulk", data, { headers: authHeader() })
      .then((res) => {
        return res.data;
      });
  }

  // Add New Ticket
  async addNewTicket(data) {
    return await axios
      .post(API_URL + "crm/ticket", data, { headers: authHeader() })
      .then((res) => {
        return res.data;
      });
  }

  // Get Detailed Ticket Data
  async getDetailedTicket(id) {
    return await axios
      .get(API_URL + "crm/ticket/" + id, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Edit Ticket
  async updateTicket(id, data) {
    return await axios
      .patch(API_URL + `crm/ticket/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Create Ticket Logs
  async createTicketLog(id, data) {
    return await axios
      .post(API_URL + `crm/ticket-activity/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Get Ticket Logs
  async getTicketLog(id) {
    return await axios
      .get(API_URL + `crm/ticket-activity/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Delete Ticket
  async deleteTicket(id) {
    return await axios
      .delete(API_URL + "crm/ticket/" + id, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Get All Titles Non-Super Admin
  async getTicketTitlesNonSup(filter = "") {
    return await axios
      .get(API_URL + `crm/ticket-title${filter}`, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get All Titles Non-Super Admin
  async getTicketDepNonSup(filter = "") {
    return await axios
      .get(API_URL + `crm/ticket-department${filter}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get All Titles
  async getTicketTitles(filter = "") {
    return await axios
      .get(API_URL + `crm/spa/ticket-title${filter}`, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add New Title
  async addNewTitle(data) {
    return await axios
      .post(API_URL + "crm/spa/ticket-title", data, { headers: authHeader() })
      .then((res) => {
        return res.data;
      });
  }

  // Edit Ticket
  async updateTitle(id, data) {
    return await axios
      .patch(API_URL + `crm/spa/ticket-title/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Get Agent Wise Performance
  async getAgentPerformance(filter = "") {
    return await axios
      .get(API_URL + `crm/ticket-solved-avg-by-user${filter}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Priority Average of Tickets
  async getAveragePerformance(filter = "") {
    return await axios
      .get(API_URL + `crm/ticket-solved-avg-by-priority${filter}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new TicketService();
